import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { i18n } from 'i18next';
import { ModalSlot } from '../plugin-loaders/ModalSlot';

export const ModalUi = ({ store, i18n }: Props) => (
    <React.StrictMode>
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <div className='idt-slot'>
                    <ModalSlot />
                </div>
            </I18nextProvider>
        </Provider>
    </React.StrictMode>
);

type Props = {
    store: PdpStore;
    i18n: i18n;
};